import { render, staticRenderFns } from "./BatchTransferList.vue?vue&type=template&id=846c196e&"
import script from "./BatchTransferList.vue?vue&type=script&lang=js&"
export * from "./BatchTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports